export default __webpack_public_path__ + "static/media/arrow-down.562ad392.svg";